import { type Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge";
import { useTranslation } from "react-i18next";
import { assert } from "utils";

import { AlternateTab } from "src/components/AlternateTab";
import { TabContent } from "src/components/WorkoutItemAlternateTabContent";
import { type AlternateWorkoutItemData } from "src/workouts/WorkoutEditStore";

interface ExerciseAlternateTabProps {
  alternate: AlternateWorkoutItemData;
  index: number;
  dndInstanceId: string;
  canEdit: boolean;
  isPending: boolean;
  dropIndicatorEdge: Edge | null;
  onMakeMain: (alternateId: string) => void;
  onRemove: (alternateId: string) => void;
}

export function ExerciseAlternateTab(props: ExerciseAlternateTabProps) {
  const { t } = useTranslation();
  const exercise = props.alternate.exercise;
  assert(exercise, "Exercise alternate has no exercise");

  return (
    <AlternateTab
      alternateId={props.alternate.id}
      index={props.index}
      dndInstanceId={props.dndInstanceId}
      canEdit={props.canEdit}
      isPending={props.isPending}
      dropIndicatorEdge={props.dropIndicatorEdge}
      labels={{
        markAsMain: t("workoutItem.markAsMain"),
        remove: t("workoutItem.remove"),
        removeTitle: t("workoutItem.removeAlternateTitle"),
        removeDescription: t("workoutItem.removeAlternateDescription"),
      }}
      onMakeMain={props.onMakeMain}
      onRemove={props.onRemove}
    >
      <TabContent exercise={exercise} />
    </AlternateTab>
  );
}
